var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIrArriba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 25.88L35.07 32.9501L36.49 31.5401L28 23.05L19.51 31.54L20.93 32.95L28 25.88Z",
    fill: "#002747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrArriba);
export default __webpack_public_path__ + "static/media/ir_arriba.ca8ccc0b473c5de558fdac5768e8031b.svg";
export { ForwardRef as ReactComponent };